"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNextBestOfferQueryRequestBase = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const GetNextBestPropositionQueryRequestBase_1 = require("../propositions/GetNextBestPropositionQueryRequestBase");
class GetNextBestOfferQueryRequestBase extends GetNextBestPropositionQueryRequestBase_1.GetNextBestPropositionQueryRequestBase {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '1234AB_56_C', description: 'Address the offer is intended for' }),
    (0, class_transformer_1.Expose)({ name: 'delivery_address' }),
    (0, base_models_1.IsAddressKey)(),
    tslib_1.__metadata("design:type", String)
], GetNextBestOfferQueryRequestBase.prototype, "deliveryAddress", void 0);
exports.GetNextBestOfferQueryRequestBase = GetNextBestOfferQueryRequestBase;
